import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import "./ExpensesBarChartHover.scss";
import { toMillionFormat } from "../../../utils/format"

const ExpenseBarChartHover = ({ firstColor, secondColor, data, height }) => {
  // Custom label next to each bar
  const CustomLabel = (props) => {
    const { x, y, width, value } = props;
    return (
      <text
        x={x + width + 10}
        y={y + 15}
        fill="#000"
        textAnchor="start"
        dominantBaseline="middle"
      >
        $
        {toMillionFormat(value)}
      </text>
    );
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const { elements, revenue } = payload[0].payload;

      return (
        <div className="custom-tooltip-container">
          <p className="custom-tooltip-label">{label}</p>
          <p className="custom-tooltip-revenue">Top 7 Expenses</p>
          <div className="custom-tooltip-table">
            {elements
              ?.sort((a, b) => b.value - a.value)
              .slice(0, 7)
              ?.map((item, index) => (
                <div
                  key={index}
                  className={`custom-tooltip-row ${
                    index % 2 === 1
                      ? "custom-tooltip-row-gray"
                      : "custom-tooltip-row-color"
                  } custom-tooltip-row-hover`}
                >
                  <span className="custom-tooltip-cell">{item.name}</span>
                  <span className="custom-tooltip-cell">
                    ${item.value.toLocaleString()}
                  </span>
                </div>
              ))}
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <div style={{ width: "100%", height: height, marginTop: "-40px" }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          layout="vertical"
          data={data}
          margin={{ left: 50, right: 100, top: 20, bottom: 20 }}
        >
          <defs>
            <linearGradient id="barGradient" x1="0" x2="1" y1="0" y2="0">
              <stop offset="0%" stopColor={firstColor} />
              <stop offset="100%" stopColor={secondColor} />
            </linearGradient>

            <filter id="shadow" height="130%">
              <feDropShadow
                dx="3"
                dy="3"
                stdDeviation="3"
                floodColor="rgba(0, 0, 0, 0.3)"
              />
            </filter>
          </defs>

          <YAxis
            dataKey="state"
            type="category"
            width={100}
            // tick={{ fill: "#000" }}
            axisLine={false}
            tickLine={false}
            // tick={({ x, y, payload }) => {
            //   const maxLength = 12; // adjust the max length as needed
            //   const text =
            //     payload.value.length > maxLength
            //       ? payload.value.substring(0, maxLength) + "..."
            //       : payload.value;

            //   return (
            //     <text x={x - 100} y={y + 5} fill="#000" fontSize={15}>
            //       {text}
            //     </text>
            //   );
            // }}
          />
          <XAxis type="number" hide />

          {/* Custom Tooltip */}
          <Tooltip content={<CustomTooltip />} cursor={false} />

          <Bar
            dataKey="revenue"
            fill="url(#barGradient)"
            barSize={40}
            radius={[5, 5, 5, 5]}
            label={<CustomLabel />}
            style={{ filter: "url(#shadow)" }}
            cursor={"pointer"}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ExpenseBarChartHover;
